import { assert, Test } from "oc-e2e-testrunner";
import { assertWarnungen, createStreckeWithMauerUndBreite, resetArrangement } from "./utils";
import { Segment } from "../arrangement/Segment";
import { ZElement } from "../arrangement/ZElement";

export default {
  name: "TestElementeTauschen",
};

export const testElementMitDoppeltorTauschen: Test = async () => {
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [7]);
  const s = agt.segmente[0];
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  APP.arrangement.setSelectedObjects(s.getElemente()[0]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
  });
  agt
    .getElemente()[0]
    .behalteLichteweite(
      () =>
        (agt.getElemente()[0].eAntriebAuswahlwert =
          APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
    );
  agt.update3d();
  const element = s.getElemente()[0];
  assertDoppeltorInSzene(element, s);
  assert.equals(
    2,
    s.getElemente().length,
    "Die Strecke besteht aus einem Doppeltor und einem Element."
  );
  s.empties[0].elementeAufruecken(false);
  agt.update3d();
  assert.equals(0, s.getElemente().indexOf(element), "Das Doppeltor soll das erste Element sein");
  APP.arrangement.tauscheBenachbarteElemente([element, s.getElemente()[1]]);
  assert.isTrue(s.getElemente()[1]?.isDoppeltor, "Das Doppeltor soll das zweite Element sein");
  assert.isTrue(s.getElemente()[0]?.isElement, "Das Zaunelement soll das erste Element sein");
};

export const testEinzeltorMitDoppeltorAnSegmentendeRechtsTauschen: Test = async () => {
  const einzeltorMassAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  const doppeltorMassAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [7]);
  const s = agt.segmente[0];
  agt.fillIndividuellSegmentsWithElements();
  APP.arrangement.setSelectedObjects(s.getElemente()[0]);
  agt.changeSelectedZaunElemente({
    massAuswahlwert: doppeltorMassAuswahlwert,
  });
  agt
    .getElemente()[0]
    .behalteLichteweite(
      () =>
        (agt.getElemente()[0].eAntriebAuswahlwert =
          APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
    );
  agt.update3d();
  const element = s.getElemente()[0];
  assertDoppeltorInSzene(element, s);
  APP.arrangement.setSelectedObjects(s.getElemente()[1]);
  agt.changeSelectedZaunElemente({
    massAuswahlwert: einzeltorMassAuswahlwert,
  });
  assert.equals(2, s.getElemente().length, "Die Strecke besteht aus zwei Elementen.");
  s.empties[0].elementeAufruecken(false);
  assert.equals(0, s.getElemente().indexOf(element), "Das Doppeltor soll das erste Element sein");
  APP.arrangement.tauscheBenachbarteElemente([element, s.getElemente()[1]]);
  assertWarnungen(agt, ["Anschlag kollidiert\nmit anschließendem Element!"]);
  assert.isTrue(s.getElemente()[0]?.isEinzeltor, "Das Einzeltor soll das erste Element sein");
  assert.isTrue(s.getElemente()[1]?.isDoppeltor, "Das Doppeltor soll das zweite Element sein");
};

export const testEinzeltorMitDoppeltorAnSegmentendeLinksTauschen: Test = async () => {
  const einzeltorMassAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  const doppeltorMassAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [7]);
  const s = agt.segmente[0];
  agt.fillIndividuellSegmentsWithElements();
  APP.arrangement.setSelectedObjects(s.getElemente()[0]);
  agt.changeSelectedZaunElemente({
    massAuswahlwert: doppeltorMassAuswahlwert,
  });
  agt
    .getElemente()[0]
    .behalteLichteweite(
      () =>
        (agt.getElemente()[0].eAntriebAuswahlwert =
          APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
    );
  agt.update3d();
  const element = s.getElemente()[0];
  assertDoppeltorInSzene(element, s);
  APP.arrangement.setSelectedObjects(s.getElemente()[1]);
  agt.changeSelectedZaunElemente({
    massAuswahlwert: einzeltorMassAuswahlwert,
  });
  assert.equals(2, s.getElemente().length, "Die Strecke besteht aus zwei Elementen.");
  assert.equals(0, s.getElemente().indexOf(element), "Das Doppeltor soll das erste Element sein");
  APP.arrangement.tauscheBenachbarteElemente([element, s.getElemente()[1]]);
  assertWarnungen(agt, ["Anschlag kollidiert\nmit anschließendem Element!"]);
  assert.isTrue(s.getElemente()[0]?.isEinzeltor, "Das Einzeltor soll das erste Element sein");
  assert.isTrue(s.getElemente()[1]?.isDoppeltor, "Das Doppeltor soll das zweite Element sein");
};

export const testDoppeltorAnMauerMitElementTauschen: Test = async () => {
  const { agt, s } = createStreckeWithMauerUndBreite(4, { rechts: true });
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  APP.arrangement.setSelectedObjects(s.empties);
  agt.update3d();
  agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt
    .getElemente()[0]
    .behalteLichteweite(
      () =>
        (agt.getElemente()[0].eAntriebAuswahlwert =
          APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
    );
  agt.update3d();
  const element = s.getElemente()[0];
  assertDoppeltorInSzene(element, s);
  s.getEmpties()[0]?.fillWithElements(agt.createDefaultElement());
  const elemente = s.getElemente();
  assert.equals(2, elemente.length, "Die Strecke besteht aus einem Doppeltor und einem Element.");
  assert.equals(1, elemente.indexOf(element), "Das Doppeltor soll das zweite Element sein");
  APP.arrangement.tauscheBenachbarteElemente([elemente[0], elemente[1]]);
  assert.isTrue(s.getElemente()[0]?.isDoppeltor, "Das Doppeltor soll das erste Element sein");
  assert.isTrue(s.getElemente()[1]?.isElement, "Das Zaunelement soll das zweite Element sein");
};

export const testEmptyMitDoppeltorTauschen: Test = async () => {
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  const agt = APP.arrangement;
  resetArrangement();
  agt.grundriss.setStandardForm("Strecke", [7]);
  const s = agt.segmente[0];
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();
  agt.getElemente()[1].uiRemove();
  agt.getElemente()[1].uiRemove();
  agt.update3d();
  APP.arrangement.setSelectedObjects(s.empties);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
  });
  agt
    .getElemente()[1]
    .behalteLichteweite(
      () =>
        (agt.getElemente()[1].eAntriebAuswahlwert =
          APP.richMetadata.findAuswahlwert("E_Antrieb_ohne"))
    );
  agt.update3d();
  agt.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  assertDoppeltorInSzene(element, s);
  assert.isTrue(
    // @ts-ignore
    s.getParts()[1]?.isDoppeltor,
    "Das Doppeltor soll das erste Element sein (nach dem Empty)"
  );
  // @ts-ignore
  assert.isTrue(s.getParts()[0]?.isEmpty, "Das Empty soll links vom Doppeltor sein");
  APP.arrangement.tauscheBenachbarteElemente([element, s.getParts()[0]]);
  // @ts-ignore
  assert.isTrue(s.getParts()[0]?.isDoppeltor, "Das Doppeltor soll das erste Element sein");
  // @ts-ignore
  assert.isTrue(s.getParts()[1]?.isEmpty, "Das Zaunelement soll das zweite Element sein");
};

function assertDoppeltorInSzene(element: ZElement, s: Segment) {
  assert.isTrue(s.getElemente().includes(element), "Das Doppeltor wurde gelöscht");
  assert.isTrue(element?.isDoppeltor, "ist kein Doppeltor");
  assert.equals(
    element.flügelsummenbreite + 0.04,
    element.lichteWeite,
    "die Lichteweite soll Flügelsummenbreite + 4 cm sein"
  );
}
